export const colorPalette = {
  primary: "#6631f7",
  primaryLight: "#af93fb",
  secondary: "#7e52f8",
  tertiary: "#a383fa",
  alto: "#D2D2D2",
  mine_shaftapprox: "#2E2E2E",
};
